import React, { useContext, useState, useEffect, useRef } from "react"
import FilterContext from "../../../context/filterContext"
import { isMobile } from "../../../utils/isMobile"
import { FilterParentContainer } from "./FilterParentContainer"
import { MainContainer } from "./FilterBarItems/MainContainer"
import { MainContainerMobile } from "./FilterBarItems/MainContainerMobile"
import { kebabCase } from "../../../utils/kebabCase"
import { useQuery } from "../../../utils/useQuery"
import { useHistory } from "react-router-dom"
import { SEOHome } from "../../../utils/SEOHome"

export const FilterBar = ({ data }) => {
	// Get query params
	let query = useQuery()

	// Mobile dropdown state
	const [showMobileDropdown, setShowMobileDropdown] = useState(false)

	// Set half/full bar depending on the position of search bar in mobile view
	const [barType, setBarType] = useState(true)

	// Search value from the search bar
	// const [searchValue, setSearchValue] = useState("")

	// Category filter items from the props
	const items = data.results

	// Get items from the filter context
	const filterContext = useContext(FilterContext)
	const {
		clearFilter,
		isFiltered,
		isSearched,
		filterCat,
		setFilterCategory,
		searchQuery,
		setSearchQuery,
	} = filterContext

	useEffect(() => {
		setFilterCategory(kebabCase(query))
		if (query !== "all") {
			toggleMobileMenu()
		}
	}, [])

	// Toggle mobile menu
	function toggleMobileMenu() {
		if (showMobileDropdown) {
			setShowMobileDropdown(false)
		} else {
			setShowMobileDropdown(true)
		}
	}

	const handleClick = (e, selectedCategory) => {
		setFilterCategory(kebabCase(selectedCategory))
		if (selectedCategory !== "all") {
			toggleMobileMenu()
		}
	}

	const handleInputChange = (e) => {
		setSearchQuery(e.target.value)
	}

	const resetSearch = () => {
		setSearchQuery("")
	}

	var isHome = true
	if (query !== "all") {
		isHome = false
	}

	return (
		<>
			<FilterParentContainer>
				{isHome ? <></> : <SEOHome data={data} />}
				{isMobile() ? (
					<MainContainerMobile
						showMobileDropdown={showMobileDropdown}
						barType={barType}
						handleInputChange={handleInputChange}
						searchValue={searchQuery}
						toggleMobileMenu={toggleMobileMenu}
						items={items}
						handleClick={handleClick}
						setBarType={setBarType}
						activeCategory={filterCat}
						clearFilter={clearFilter}
						resetSearch={resetSearch}
					/>
				) : (
					<MainContainer
						handleClick={handleClick}
						items={items}
						searchValue={searchQuery}
						handleInputChange={handleInputChange}
						clearFilter={clearFilter}
						resetSearch={resetSearch}
						isFiltered={isFiltered}
						isSearched={isSearched}
						activeCategory={filterCat}
					/>
				)}
			</FilterParentContainer>
		</>
	)
}
